module.exports = __webpack_public_path__ + "media/images/autopilot/robot-outline-primary-156516ab2ca432525dbb7483cf0d763a.svg";